import { CourseEvaluationState } from './courseEvaluation-state.enum'

export enum EnrolState {
  Pending = 0,
  Approved = 1,
  Denied = 2,
  Absent = 3,
  ExcusedAbsence = 4,
}

const { Approved, Denied, Pending, Absent, ExcusedAbsence } = EnrolState
export const getTranslationEnrolStateKey = (modality: EnrolState) => {
  const modalities = {
    [Approved]: 'approved',
    [Denied]: 'denied',
    [Pending]: 'pending',
    [Absent]: 'absent',
    [ExcusedAbsence]: 'excusedAbsence',
  }
  return modalities[modality] || modalities[Pending]
}

export const FINAL_STATE_MAP_EVALUATION_STATE = {
  [EnrolState.Approved]: CourseEvaluationState.approved,
  [EnrolState.Denied]: CourseEvaluationState.failed,
  [EnrolState.Pending]: CourseEvaluationState.inProcess,
}
